<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title || t('improveDetail.title')" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskName')" prop="title">
                            {{ taskInfo.title }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.score')" prop="score">
                            {{ taskInfo.score }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.staffLimit')" prop="staff">
                            {{ taskInfo.staff > 0 ? taskInfo.staff : t('improveDetail.unlimited') }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskDesc')" prop="end_time">
                            {{ taskInfo.description }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.taskMaterial')">
                            <!-- {{ taskFileList }} -->
                            <hc-oss-image-list :value="taskInfo.url" />
                            <!-- <el-upload v-model:file-list="taskFileList" list-type="picture-card">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload> -->
                        </el-form-item>
                    </el-col>

                    <el-divider></el-divider>
                    <!-- <el-col :span="24">
                       {{ state}}
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.submitter')">
                            {{ state.row.real_name }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitPhotos')">
                            <hc-oss-image-list :value="state.row.material_url" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitContent')">
                            {{ state.row.note }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.auditComment')" prop="comment">
                            {{ state.form.comment }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.passStatus')" prop="status">
                            {{ statusMap[state.form.status] }}
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('improveDetail.close') }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    computed,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { auditApi, detailApi } from "@/api/improve/record";
import { detailApi as taskDetailApi } from "@/api/improve/improve";
import { usePageI18n } from "@/composables/usePageI18n.js";

const statusMap = ref({})

const applyLabels = () => {
    statusMap.value = {
        3: t('improveDetail.passed'),
        4: t('improveDetail.rejected')
    };
};
const { t } = usePageI18n(applyLabels);

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "",
    }
});

const rules = reactive({
    // username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    // real_name: [{ required: true, message: "请输入手机", trigger: "blur" }],
});

const state = reactive({
    dialogVisible: false,
    row: {},
    form: {
        "id": 0,
        "replied_by": 0,
        "replied_name": "",
        "note":"",
        "comment": "",
        "status": 0
    }
});

const taskInfo = ref({})
const taskFileList = computed(() => {
    return JSON.parse(taskInfo?.value?.url ?? "[]")
})
const getTaskDetailInfo = (taskId) => {
    const params = JSON.stringify({
        id: taskId
    })
    taskDetailApi(params).then(res => {
        if (res.code === 200) {
            taskInfo.value = res.data ?? {}
        }
    })
}

const getDetailInfo = (row = {}) => {
    if (row?.id) {
        const params = JSON.stringify({
            "id": row.id
        })
        detailApi(params).then(res => {
            if (res?.code !== 200) return
            state.form = {
                "id": res.data.id,
                "replied_by": row.repliedBy,
                "replied_name": row.repliedName,
                "comment": row.comment,
                "status": row.status,
            }
        })
    } else {
        state.form.id = 0
    }
}

const open = (row) => {
    state.dialogVisible = true;
    state.row = row
    getDetailInfo(row)
    getTaskDetailInfo(row.task_id)
};

const getImgArr = (str) => {
    if (!str || str.length === 0) {
        return []
    }
    return JSON.parse(str).map(i => i.url)
}

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const { user } = JSON.parse(localStorage.getItem("user"));
            const params = JSON.stringify({
                ...toRaw(state.form),
                "replied_by": user.users.id,
                "replied_name": user.users.realName,
            })
            auditApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('improveDetail.opSuccess'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "replied_by": 0,
                        "replied_name": "",
                        "comment": "",
                        "status": 0
                    }
                    emit('refresh')
                } else {
                    ElMessage.error(res?.msg || t('improveDetail.opFailed'))
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
    try {
        if (row?.id) {
            getTemplateInfo();
        } else {
            form.id = 0
        }
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}

.record-img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
